import React, { useState } from "react";
import { FaPlus, FaMinus, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../redux/Actions/CartActions";
import { formatNumber, rateUsdt } from "../service";
import { BuyNowButton } from "../components/BuyNowButton";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Breadcrumb from "../components/Breadcrumb";

const CartScreen = () => {
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const total = cartItems.reduce((a, i) => a + i.qty * i.price, 0).toFixed(2);
  // const [cartItems, setCartItems] = useState([
  //   {
  //     id: 1,
  //     name: "Kinder Joy",
  //     description: "Egg Kinder Milk Chocolate Surprise with toy 20g",
  //     price: 17.0,
  //     quantity: 1,
  //     image:
  //       "https://m.media-amazon.com/images/I/61+9R+2ErhL._AC_UL320_.jpg", // demo link, bạn thay bằng ảnh khác
  //   },
  // ]);

  const handleIncrease = (productId, qty) => {
    dispatch(addToCart(productId, qty));
  };

  const handleDecrease = (productId, qty) => {
    dispatch(addToCart(productId, qty));
  };

  // const handleRemove = (id) => {
  //   setCartItems((prev) => prev.filter((item) => item.id !== id));
  // };

  // const subtotal = cartItems.reduce(
  //   (acc, item) => acc + item.price * item.quantity,
  //   0
  // );
  // const checkOutHandler = () => {
  //   // history.push("/login?redirect=shipping");
  //   history.push("/shipping");
  // };

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };
  const breadcrumbItems = [
    { label: "Trang chủ", href: "/" },
    { label: "Giỏ hàng", href: `/cart` },
];
  return (
    <>  
    <Breadcrumb items={breadcrumbItems} />
    <div className="w-full  flex justify-center items-center mt-8 p-4 xl:p-0">
      <div className="w-[--page-width] ">
        {cartItems.length <= 0 && <div className="text-sm text-center p-16 col-span-2 flex flex-col justify-center items-center gap-4 ">
          <p>Giỏ hàng trống</p>

          <Link to="/" className="bg-[--color-button-3] w-auto px-6 py-2 rounded-full text-white text-sm font-bold 
                    hover:bg-[--color-button-2] hover:text-black transition-all duration-200 ">
            <button>Tiếp tục mua sắm</button>
          </Link>
        </div>}
        {/* <h1 className="text-2xl font-semibold mb-6">Giỏ hàng</h1> */}

        {cartItems.length > 0 && <> <div className="border-b pb-2 font-semibold grid grid-cols-3 md:grid-cols-5 gap-4 text-sm">
          <div className="col-span-2">Sản phẩm</div>
          <div className="text-center hidden md:block">Số lượng</div>
          <div className="text-right">Thành tiền</div>
        </div>

          {cartItems?.map((item) => (
            <div
              key={item.id}
              className="grid grid-cols-3 md:grid-cols-5 gap-4 items-center py-4 border-b"
            >
              {/* Product */}
              <div className="col-span-2 flex gap-3 items-center">
                <img
                  src={item.image?.url}
                  alt={item.name}
                  className="w-32 h-32   object-contain border rounded"
                />
                <div>
                  <div>
                    <h2 className="font-semibold">{item.name}</h2>
                    <p className="text-sm text-gray-600">{item.description}</p>
                    <p className="text-[--color-button-3] font-medium">
                      {item.price.toFixed(2)}
                    </p>
                  </div>
                  {/* Quantity */}
                  <div className="flex md:hidden justify-center items-center gap-2">
                    <button
                      onClick={() => handleDecrease(item.product, item.qty - 1 <= 0 ? 0 : item.qty - 1)}
                      className="border px-2 py-1 rounded"
                    >
                      <FaMinus size={12} />
                    </button>
                    <span>{item.qty}</span>
                    <button
                      onClick={() => handleIncrease(item.product, item.qty + 1)}
                      className="border px-2 py-1 rounded"
                    >
                      <FaPlus size={12} />
                    </button>
                    <button
                      onClick={() => removeFromCartHandler(item.product)}
                      className="ml-3 bg-[--color-button-3] hover:bg-[--color-button-2] text-white p-2 rounded-full"
                    >
                      <FaTrash size={12} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Quantity */}
              <div className="hidden md:flex justify-center items-center gap-2">
                <button
                  onClick={() => handleDecrease(item.product, item.qty - 1 <= 0 ? 0 : item.qty - 1)}
                  className="border px-2 py-1 rounded"
                >
                  <FaMinus size={12} />
                </button>
                <span>{item.qty}</span>
                <button
                  onClick={() => handleIncrease(item.product, item.qty + 1)}
                  className="border px-2 py-1 rounded"
                >
                  <FaPlus size={12} />
                </button>
                <button
                  onClick={() => removeFromCartHandler(item.product)}
                  className="ml-3 bg-[--color-button-3] hover:bg-[--color-button-2] text-white p-2 rounded-full"
                >
                  <FaTrash size={12} />
                </button>
              </div>

              {/* Total */}
              <div className="text-right font-bold text-[--color-button-3]" >
                {(item.price * item.qty).toFixed(2)}
              </div>
            </div>
          ))}

          {/* Continue shopping */}
          <div className="mt-8">
            <Link to={"/"} className="bg-[--color-button-3] text-white px-5 py-2 rounded-full hover:bg-[--color-button-2] hover:text-black">
              Tiếp tục mua sắm
            </Link>
          </div>

          <div className="flex flex-col md:flex-row justify-between mt-8 gap-4">
            {/* Special instructions */}
            <div className="w-full md:w-1/2 lg:w-1/3">
              <label className="block text-sm mb-2 font-medium">
                Ghi chú đơn hàng
              </label>
              <textarea
                rows="3"
                className="w-full border rounded p-2 placeholder:text-sm"
                placeholder="Ghi chú đơn hàng"
              ></textarea>
            </div>
            {/* Checkout */}
            <div className=" flex flex-col justify-between items-end w-full md:w-1/2 lg:w-2/3">
              <div className="flex flex-col justify-end gap-4">
                <p className="font-bold flex gap-2 justify-end ">
                  Tổng tiền:
                  <div className="flex gap-2 text-[--color-button-3]">
                    <img src="/images/logoToken.png" style={{ width: 20 }} /> {(Number(total)).toFixed(2)} <span className="text-black">({formatNumber(total * rateUsdt)}đ)</span>
                  </div>
                </p>
                <p className="text-sm text-gray-500">
                  Thuế và phí vận chuyển được tính khi thanh toán
                </p>
              </div>
              <BuyNowButton className={"w-full lg:w-[30%] text-center"} />
            </div>
          </div>
        </>}
      </div>

    </div>
    </>
  );
};

export default CartScreen;
